export enum PromoType {
  bogo = 'bogo',
}
